import { render, staticRenderFns } from "./VolunteerProfile.vue?vue&type=template&id=61496204"
import script from "./VolunteerProfile.vue?vue&type=script&lang=js"
export * from "./VolunteerProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports